<template>
  <b-container>
    <b-row align-v="center">
      <b-col sm="12" md="6">
        <div class="align-content-center">
          <b-card>

            <slot>
              Mensagem
            </slot>
            <loading-spinner v-if="isLoading"></loading-spinner>

            <p v-if="attempt < tries && !isLoading && showDelayMessage">Tentando novamente em {{ retryIn }}
              segundos.</p>
            <br v-else/>

            <b-button :disabled="buttonLocked" v-if="!isLoading" @click="retryButtonClicked" variant="secondary">
              {{ buttonLabel }}
            </b-button>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { LoadingSpinner } from '@/components/loaders'

  export default {
    name: 'retry',

    components: {
      LoadingSpinner,
    },

    props: {
      delay: Number,
      tries: Number,
      maxButtonTries: Number,
      delayUnlockButton: Number,
      buttonLabel: {
        type: String,
        default () {
          return 'Clique aqui para tentar novamente'
        },
      },
      showDelayMessage: {
        type: Boolean,
        default () {
          return true
        },
      },
    },

    data () {
      return {
        attempt: 0,
        actualButtonAttempt: 0,

        isLoading: false,
        retryIn: this.delay,

        buttonLocked: false,
      }
    },

    mounted () {
      this.startChronometer()
    },

    methods: {
      retryButtonClicked () {
        this.isLoading = true
        setTimeout(() => {
          this.emitRetry()
          this.isLoading = false
          this.retryIn = this.delay
          this.actualButtonAttempt++
        }, 500)

        this.handleButtonLock()
      },

      handleButtonLock () {
        if (this.maxButtonTries && this.actualButtonAttempt === this.maxButtonTries - 1) {
          this.buttonLocked = true

          let unlockButtonInSeconds = 5
          if (this.delayUnlockButton) {
            unlockButtonInSeconds = this.delayUnlockButton
          }

          setTimeout(() => {
            this.buttonLocked = false
            this.actualButtonAttempt = 0
          }, unlockButtonInSeconds * 1000)
        }
      },

      emitRetry () {
        this.$emit('onRetry')
      },

      updateShowingChronometerAs (option) {
        if (option === 'decrease') {
          this.retryIn--
        } else if (option === 'reset') {
          this.isLoading = true
          setTimeout(() => {
            this.isLoading = false
            this.startChronometer()
            this.retryIn = this.delay
          }, 500)
        }
      },

      startChronometer () {
        this.setupShowingChronometer()
        if (this.attempt < this.tries) {
          setTimeout(() => {
            this.attempt++
            this.emitRetry()
            this.updateShowingChronometerAs('reset')
          }, this.delay * 1000)
        }
      },

      setupShowingChronometer () {
        if (this.attempt === 0) {
          setInterval(() => {
            if (this.attempt < this.tries) {
              this.updateShowingChronometerAs('decrease')
            }
          }, 1000)
        }
      },
    },
  }
</script>
